import uniqid from 'uniqid';
import PropTypes from 'prop-types';
import GuestReview from './guestReview';
import './guestReviewNuggetList.scss';

const MAX_NR_OF_REVIEWS = 3;

const GuestReviewNuggetList = ({ reviews = [], labels }) => {
  const noHotelReviewInfo =
    (labels && labels.noHotelReviewInfo) || 'No reviews';

  if (!reviews || reviews.length < 1) {
    return (
      <div className="gw-guest-review-list__text-wrapper">
        <p className="gw-guest-review-list__placeholder-text">
          {noHotelReviewInfo}
        </p>
      </div>
    );
  }

  return (
    <div className="gw-guest-review-list">
      {reviews.slice(0, MAX_NR_OF_REVIEWS).map((r) => {
        return (
          <div
            className="gw-guest-review-list-item"
            key={uniqid('gw-guest-review-list-item-')}
          >
            <GuestReview review={r} labels={labels} />
          </div>
        );
      })}
    </div>
  );
};

GuestReviewNuggetList.propTypes = {
  labels: PropTypes.shape({
    noHotelReviewInfo: PropTypes.string,
  }).isRequired,
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      rating: PropTypes.number,
      maxRating: PropTypes.number,
      body: PropTypes.string,
      member: PropTypes.shape({
        id: PropTypes.string,
        alias: PropTypes.string,
      }),
      date: PropTypes.shape({
        long: PropTypes.string,
        raw: PropTypes.string,
      }),
    }),
  ),
};

export default GuestReviewNuggetList;
